import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20background%20with%20flowing%20warm%20golden%20and%20amber%20light%20streaks%20on%20deep%20charcoal%20surface%2C%20elegant%20curves%2C%20modern%20streaming%20platform%20aesthetic%2C%20smooth%20gradients%2C%20no%20text%2C%20atmospheric&width=1800&height=900&seq=mogu-hero-bg&orientation=landscape"
        alt="蘑菇视频高清在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-background-50 mb-4 leading-tight">
            蘑菇视频
          </h1>
          <p className="text-base md:text-xl text-background-50/85 mb-3 leading-relaxed">
            西瓜视频免费 · 蜜桃视频 · 高清在线观看
          </p>
          <p className="text-sm md:text-lg text-background-50/70 mb-8 max-w-2xl mx-auto leading-relaxed">
            聚合优质影视资源，提供<strong className="text-background-50">高清电影电视剧免费在线观看</strong>，<strong className="text-background-50">无广告流畅播放</strong>，VIP电影免费看，1080P画质
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/dianying"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-base transition-all duration-200 whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-play-circle-fill text-xl"></i>
              立即观影
            </Link>
            <Link
              to="/category/dianshiju"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-lg text-base transition-all duration-200 whitespace-nowrap border border-background-50/20 flex items-center justify-center gap-2"
            >
              <i className="ri-tv-2-line text-xl"></i>
              追剧专区
            </Link>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">5000万+</p>
              <p className="text-xs md:text-sm text-background-50/60 mt-1">累计用户</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">10万+</p>
              <p className="text-xs md:text-sm text-background-50/60 mt-1">影视资源</p>
            </div>
            <div className="w-px h-10 bg-background-50/20 hidden sm:block"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">1080P</p>
              <p className="text-xs md:text-sm text-background-50/60 mt-1">高清画质</p>
            </div>
            <div className="w-px h-10 bg-background-50/20 hidden sm:block"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">0广告</p>
              <p className="text-xs md:text-sm text-background-50/60 mt-1">纯净观影</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}